import ko from "knockout";
import { DataSet } from "vis-data";
import { Timeline } from "vis-timeline/peer";

// Usage: <div data-bind="visTimeline: { data: dataSet, groups: groupDataSet, options: timelineOptions, callback: callAfterTimelineCreated}"></div>
// See http://visjs.org/docs/timeline/#Data_Format for available data types for dataSet and groupDataSet
// See http://visjs.org/docs/timeline/#Configuration_Options for available timelineOptions values

ko.bindingHandlers.visTimeline = {
    init: function (element, valueAccessor) {
        const bindingData = ko.unwrap(valueAccessor());
        const data = bindingData.data
            ? ko.unwrap(bindingData.data)
            : new DataSet();
        const groups = bindingData.groups
            ? ko.unwrap(bindingData.groups)
            : undefined;
        const options = bindingData.options
            ? ko.unwrap(bindingData.options)
            : {};
        const callback = bindingData.callback
            ? ko.unwrap(bindingData.callback)
            : undefined;
        const itemTemplateId = bindingData.itemTemplateId
            ? ko.unwrap(bindingData.itemTemplateId)
            : undefined;
        const groupTemplateId = bindingData.groupTemplateId
            ? ko.unwrap(bindingData.groupTemplateId)
            : undefined;

        if (itemTemplateId !== undefined) {
            options.template = function (item) {
                if (!document.getElementById(itemTemplateId)) {
                    return document.createElement("div"); // return a default element
                }

                const templateHtml =
                    document.getElementById(itemTemplateId).innerHTML;

                // Set the template to a custom template which lets knokcout bind the items
                // Create a div wrapper element to easily create elements from the template HTML
                const element = document.createElement("div");
                element.innerHTML = templateHtml;

                // Let knockout apply bindings on the element with the template, using the item as data context
                ko.applyBindings(item, element);

                //Return the bound element to vis.js, for adding in the component
                return element;
            };
        }

        if (groupTemplateId !== undefined) {
            options.groupTemplate = function (item) {
                if (!document.getElementById(groupTemplateId)) {
                    return document.createElement("div"); // return a default element
                }

                const templateHtml =
                    document.getElementById(groupTemplateId).innerHTML;

                // Set the template to a custom template which lets knokcout bind the items
                // Create a div wrapper element to easily create elements from the template HTML
                const element = document.createElement("div");
                element.innerHTML = templateHtml;

                // Let knockout apply bindings on the element with the template, using the item as data context
                ko.applyBindings(item, element);

                //Return the bound element to vis.js, for adding in the component
                return element;
            };
        }

        if (options.showTooltips) {
            options.tooltip.template = function (item) {
                const container = document.createElement("div");
                container.classList.add("vis-tooltip-inner");

                ko.renderTemplate(
                    "templates/timelineTooltip",
                    item,
                    {},
                    container,
                    "replaceChildren"
                );
                return container;
            };
        }

        //Apply the vis.js timeline component
        const timeline = new Timeline(element, data, groups, options);
        timeline.redraw();

        if (callback !== undefined) {
            callback(timeline);
        }

        //Let knockout know that we want to handle bindings for child items manually
        return {
            controlsDescendantBindings: true,
        };
    },
};
